export default "__VITE_ASSET__DjjI5Ich__"